<template>
    <v-col>
        <v-row class="pl-3">{{Fio}}</v-row>
        <v-row>
            <v-col class="pa-0 pl-3 pt-2" cols="1">Рейтинг: </v-col>
            <v-col class="pa-0"><v-rating readonly v-model="Rat"></v-rating></v-col>
        </v-row>
        <v-row>
            <v-col class="pa-0 pl-3" cols="1">Отзыв: </v-col>
            <v-col class="pa-0">{{otz}}</v-col>
        </v-row>
    </v-col>
</template>

<script>
export default {
    props:["Fio", "Rat", "otz"]
}
</script>